<script setup>
import { onMounted, shallowRef } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import UiAuthLayout from '@/components/ui/UiAuthLayout.vue';
import UiNewPasswordForm from '@/components/ui/UiNewPasswordForm.vue';
import { apiRequest, errorMessage } from '@/api/http';
import { clearSession, homePathFor, signInWithToken } from '@/api/session';

// Shown right after signing in with a password an admin set (Add account,
// a reset or a temporary password): the user must choose their own before
// using the app. The server refuses everything else until they do.
const router = useRouter();
const store = useStore();
const saving = shallowRef(false);
const error = shallowRef('');

onMounted(() => {
  const user = store.state.user;
  if (!localStorage.getItem('token') || !user) router.replace('/login');
  else if (!Number(user.user?.mustChangePassword)) router.replace(homePathFor(user));
});

async function save(password) {
  saving.value = true;
  error.value = '';
  try {
    const body = await apiRequest('post', '/auth/complete-password-change', { password });
    const user = await signInWithToken(store, body.token);
    await router.replace(user ? homePathFor(user) : '/login');
  } catch (e) {
    error.value = errorMessage(e, 'Could not save your password. Please try again.');
    saving.value = false;
  }
}

function signOut() {
  clearSession(store);
  router.replace('/login');
}
</script>

<template>
  <UiAuthLayout
    title="Choose a new password"
    description="Your administrator set a temporary password for you. Choose your own to continue."
  >
    <UiNewPasswordForm submit-text="Save password and continue" :loading="saving" :error="error" @submit="save" />

    <template #footer>
      Not you? <a href="#" @click.prevent="signOut">Sign out</a>
    </template>
  </UiAuthLayout>
</template>
